<template>
  <div class="print-tag-main-view">
    <PrinterPluginDownloadModal
      ref="webSocketPluginDownloadModal"
      ref-name="webSocketPluginDownloadModal"
    />

    <modal
      ref="printingModal"
      template="loading"
      title="Aguarde"
      ref-name="printingModal"
    >
      <p>Imprimindo etiquetas...</p>
    </modal>

    <!-- both -->
    <modal
      ref="loadingReceiptModal"
      template="loading"
      title="Aguarde"
      ref-name="loadingReceiptModal"
    >
      <p>Gerando recibo...</p>
    </modal>

    <!-- batch -->
    <md-dialog
      id="dialogHelp"
      ref="dialogHelp"
      :md-esc-to-close="false"
      :md-click-outside-to-close="false"
      class="batches-help send-batches modals"
    >
      <md-dialog-title>
        Ajuda sobre lotes
        <button
          id="mod_btnCloseHelp"
          class="close-button btn-transparent"
          @click="$refs.dialogHelp.close()"
        >
          <md-icon>clear</md-icon>
        </button>
      </md-dialog-title>

      <md-dialog-content>
        <p>
          Para agilizar o processamento dos exames e prover resultados mais rapidamente, as amostras agora são agrupadas em lotes. Além de etiqueta de cada amostra, a impressão
          também irá gerar uma etiqueta para cada lote agrupado de amostras.
        </p>

        <p>
          <strong>Veja como é simples organizar as amostras em lotes:</strong>
        </p>

        <ul class="batch-help__icons">
          <li
            v-for="(item, rowIndex) in $strings.batchHelpSteps"
            :key="rowIndex"
          >
            <div class="img-container">
              <img
                :src="'/static/images/icon-help-batch-0' + (rowIndex + 1) + '.svg'"
                alt
              />
            </div>
            <caption>
              {{ item }}
            </caption>
          </li>
        </ul>

        <md-layout :md-gutter="24">
          <md-layout>
            <strong>Etiqueta de amostra:</strong>
            Deve ser colada na amostra sobre a etiqueta primária original. Contém a informação do lote ao qual pertence.
          </md-layout>
          <md-layout>
            <strong>Etiqueta de lote:</strong>
            Deve ser colada na embalagem plástica que contém as amostras correspondentes do lote.
          </md-layout>
        </md-layout>
      </md-dialog-content>
    </md-dialog>

    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
import notify from '@/api/notification';
import { mapGetters, mapActions } from 'vuex';
import PrintWebSocketService from '@/services/PrintWebSocketService';
import EmptyCart from '@/components/common/EmptyCart';
import SamplesList from '@/components/PrintTag/Samples/SamplesList';
import PrinterPluginDownloadModal from '@/components/common/printer/PrinterPluginDownloadModal.vue';

export default {
  name: 'PrintTag',
  components: {
    'empty-cart': EmptyCart,
    'samples-list': SamplesList,
    PrinterPluginDownloadModal,
  },
  computed: {
    ...mapGetters(['samplePrintingStatus', 'profile', 'webSocketStatus', 'toggle']),
  },
  watch: {
    samplePrintingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_PRINTING':
          this.$analytics.pushAnalyticsEvent('vpageview', {
            page: 'batches/printing-modal',
            'id-usuario': this.profile.id,
            'id-lab': this.profile.id_laboratory,
            nlab: this.profile.laboratoryName,
          });
          this.$refs.printingModal.open();
          break;
        case 'STATUS_INITIAL':
          this.$refs.printingModal.close();
          break;
        case 'STATUS_MISSING_CLIENT':
          this.$refs.printingModal.close();
          notify({
            title: 'AVISO:',
            message: 'Erro ao conectar à impressora. Por favor, verifique se o cliente de impressão está instalado ou faça login novamente.',
          });
          break;
        default:
          break;
      }
    },
  },
  async created() {
    if (this.toggle.printerPlugin) {
      await this.connectWebSocket();
    }
  },
  beforeDestroy() {
    PrintWebSocketService.disconnect();
  },
  methods: {
    ...mapActions(['initializeWebSocket', 'updateWebSocketStatus']),

    async connectWebSocket() {
      try {
        await PrintWebSocketService.disconnect();
        await new Promise(resolve => setTimeout(resolve, 2000));

        this.updateWebSocketStatus('connecting');
        await this.initializeWebSocket();

        if (this.webSocketStatus.connectionState !== 'connected') {
          throw new Error('WebSocket connection failed');
        } else if (this.webSocketStatus.hasNewVersion) {
          this.$nextTick(() => {
            this.$refs.webSocketPluginDownloadModal.open();
          });
        }
      } catch (error) {
        console.error('Erro na conexão:', error);
        this.updateWebSocketStatus('disconnected');
        this.$nextTick(() => {
          this.$refs.webSocketPluginDownloadModal.open();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/stylesheets/variables';
@import '../../../static/stylesheets/mixins';
@import '../../../static/stylesheets/components/orders/empty-cart';

.print-tag-main-view {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: $contentContainerHeight;
  padding-top: $mainHeaderHeight;
  font-family: 'Exo 2', sans-serif !important;

  &__table-list_container {
    width: 100%;

    /* IE10 & IE11 CSS styles go here */
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      display: table;
    }
    .samples-list_container {
      margin-top: 1em;
    }
  }

  &.md-snackbar {
    .md-snackbar-container {
      width: auto;
      font-family: 'Exo 2', sans-serif !important;
      font-style: normal;
      font-weight: normal;
      text-align: center;
      background-color: #7f1a54;
      color: white;
      margin: 0;
      max-width: max-content;
      padding: 11px 24px;
      min-height: min-content;
    }
  }
}
.fixed-head {
  position: relative !important;
  width: 100% !important;
}

.apoio-datatable {
  margin-top: 0px !important;
}

.sort-icon {
  position: relative;
}

.empty-cart {
  margin: 0;
  img {
    height: 112px;
  }
}

.multiselect__select {
  &::after {
    border: 1px solid gray;
  }
}

.batch-details-title {
  display: flex;
  cursor: pointer;

  h2 {
    margin: 0.7em;
  }

  .md-icon {
    height: 1px;
  }
}

.batches-list-bar {
  height: 75px;
  position: fixed;
  background: #ebebeb;
  z-index: 2;
  display: inline-flex;
  left: 0;

  .md-gutter-30 {
    &:not(.md-column) {
      margin-right: -15px;
      margin-left: -15px;

      > .md-layout {
        padding-right: 15px;
        padding-left: 15px;
      }
    }
  }

  &__button-container {
    flex-flow: row-reverse;
    width: 430px;
    display: flex;
    padding-top: 14px;

    .btn {
      white-space: nowrap;
    }
  }

  &__btn-print-label {
    width: 191px;

    &__icon {
      margin: 0 0 0 0;
      padding-right: 10px;
      width: 11px;
      height: 11px;
      min-height: 11px;
    }

    &:disabled {
      background-color: #d9d9d9;
      cursor: not-allowed;
    }
  }

  &__btn-close-send {
    width: 219px;
    margin-right: 20px;
    order: 1;

    &__icon {
      margin: 0 0 0 0;
      padding-right: 8px;
      width: 24px;
      height: 19px;
      min-width: 19px;
      min-height: 19px;
    }
  }
}

.send-batches {
  &.modals .md-dialog {
    min-width: 660px;
    min-height: 230px;

    p {
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-size: 18px;
      letter-spacing: -0.2px;
      text-align: center;
      color: #303030;
      margin-bottom: 10px;
    }
  }
}

.switch-modal {
  &.modals .md-dialog {
    min-width: 660px;
    min-height: 320px;
  }

  p {
    text-align: center;
    font-size: 18px;
    padding: 20px 0 60px;
  }
}

.batches-help.md-dialog-container {
  .md-dialog {
    width: 660px;

    p,
    li,
    .md-layout {
      color: rgba(96, 96, 96, 0.87);
    }

    .batch-help__icons {
      display: flex;
      justify-content: space-between;
      margin: 23px 0 30px;

      li {
        display: flex;
        margin-top: 0;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: -0.2px;
        text-align: center;
        flex-direction: column;
        width: 114px;
        line-height: 1.4;
        background: url(/static/images/icon-arrow.png) no-repeat 72px 33px;

        &:last-child {
          width: 72px;
          background: transparent;
        }
      }

      .img-container {
        width: 72px;
        height: 72px;
        border-radius: 6px;
        border: solid 1px #dbdbdb;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;

        img {
          width: 56px;
          height: 56px;
          object-fit: contain;
        }
      }

      caption {
        width: 72px;
        text-align: center;
      }
    }

    p {
      text-align: left;
      font-size: 15px;
      letter-spacing: -0.2px;
      margin-bottom: 18px;
      line-height: 1.2;
    }

    strong {
      font-weight: 500;
    }
  }
}

.search-bar__search {
  flex: 3 !important;
}
.search-bar__date {
  flex: 3 !important;
}

@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
  /* IE10+ */
  .search-bar__search {
    flex: 3;
  }
  .search-bar__date {
    flex: 3;
  }
}

@supports (-ms-ime-align: auto) {
  /* Edge+ */
  .search-bar__search {
    flex: 3;
  }
  .search-bar__date {
    flex: 3;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.transition-enter-active {
  transition: opacity 0.5s;
  transition-delay: 0.5s;
}
.transition-leave-active {
  transition: opacity 0.5s;
}
.transition-enter, .transition-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
</style>
